import { useRequiredContext } from "@suse-o11y/use-required-context";
import { createContext } from "react";

import type { TimestampCursorState } from "./TimestampCursorState";

const TimestampCursorContext = createContext<null | TimestampCursorState>(null);

export const TimestampCursorContextProvider = TimestampCursorContext.Provider;

export const useTimestampCursorState = (): TimestampCursorState =>
	useRequiredContext(TimestampCursorContext, {
		providerName: "TimestampCursorProvider",
	});
